import { Component, computed, effect, inject } from '@angular/core';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { BranchService } from '@app/services/branch/branch.service';
import { Appointment } from '@app/services/fetch/appointment';
import { Settings } from '@app/services/fetch/settings';
import { QrCodeComponent } from 'ng-qrcode';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'afcu-tv',
  standalone: true,
  imports: [QrCodeComponent],
  templateUrl: './tv.component.html',
  styleUrl: './tv.component.css'
})
export class TvComponent extends BaseConfigurableComponent{
  
  protected branchService = inject( BranchService )
  protected settingsServices = inject( Settings );
  private readonly eventService = inject(Appointment)

  private destroy$ = new Subject<void>();
  title:string = ''
  token = this.generateToken()
  isLoading = true

  categoriesText = {
    queue: "Walk-ins",
    appointment: "Appointments",
    footer: "* The order in which you are called in depends on the staff available to assist based on the service type you have selected.",
    qr:{
      title:  "Join the queue",
      footer: "Use your device or the kiosk located at the entrance."
    },

  }

  filteredEvents = computed( () => {
    let events:TVAppt[] = this.eventService.eventsQueue()?.sort((a,b) => new Date(a.checkInTimeUTC).getTime() - new Date(b.checkInTimeUTC).getTime()) ?? []
    return {
      appointment: events.filter(event => event.type === 'appointment'),
      queue: events.filter(event => event.type === 'queue')
    }
  })
  

  constructor() {
    super('tv')
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.branch = params['location']
      this.textService.setLanguage(params['lang'])
    })

    effect(() =>{
      this.isLoading = this.branchService.items().length === 0
      
      if (!this.isLoading){
        const settings = this.settingsServices.settings()
        if (settings.tv_queue){
          this.eventService.eventRequest.set({
            branchID: this.branch,
            refresh: settings.tv_refresh
          })
          this.title = this.renderTemplate(settings.tv_queue.text[this.textService.language()].title, this.branchService.items().find( branch => branch.branchID === this.branch))
          this.categoriesText = settings.tv_queue.text[this.textService.language()]
        }
           
      }

      if(!this.settingsServices.isLoadingSettings() && this.settingsServices.categorySetting() == 'TV'){
        if(this.settingsServices.settings().allow_device){
          this.token = this.generateToken()

          setInterval(() => {
            this.token = this.generateToken()
          }, this.settingsServices.settings().allow_device.value*60*1000) 
        }
      }

      if(Object.keys(this.settingsServices.settings()).length > 0 && 
        this.settingsServices.categorySetting() == 'KIOSK') {
         this.settingsServices.categorySetting.set("TV")
      }
    })
  }

  renderTemplate(template: string, templateVariable: any): string {
    return template.replace(/{{\s*branch\.(\w+)\s*}}/g, (_, prop) => {
      const key = prop as keyof Branch;
      const value = templateVariable[key];
      return String(value ?? '');
    });
  }

  generateToken() {
    if(this.settingsServices.settings().allow_device)
      return `&token=${new Date().getTime()+this.settingsServices.settings().allow_device.value*60*1000}`
    
    return `&token=${5*60*1000}`
  }

  get linkQR() {
    return window.location.origin+'/splash?origin=kiosk&branch=' + this.branch + this.token
  }

}
